import { CorporateSectionData } from './interface/interface';
import LawFirmsImg from '../assets/images/lawfirms.png';
import AiPowered from '../assets/images/components/AiPowered';
import SmartLegalIcon from '../assets/images/components/SmartLegalIcon';
import ComprehensiveLitigationIcon from '../assets/images/components/ComprehensiveLitigationIcon';
import ContractLawIcon from '../assets/images/components/ContractLawIcon';
import CurrentJudgementIcon from '../assets/images/components/CurrentJudgementIcon';
import AutomationIcon from '../assets/images/components/AutomationIcon';

export const lawFirmsDatas: CorporateSectionData = {
  info: {
    image: LawFirmsImg,
    para1:
      'In today’s fast-paced legal landscape, staying ahead means more than just knowing the law — it requires leveraging technology to practice it smarter. For law firms and legal professionals, AI-driven tools streamline research, automate drafting, and reduce repetitive tasks—freeing up time for strategic work and client focus.',
    para2:
      'At Legalligence, we bridge the gap between legal expertise and cutting-edge technology. Our AI-assisted solutions are designed to support modern legal teams with precision, scalability, and unmatched efficiency — so you can focus on your core area.',
  },
  desc: [
    {
      title: 'Efficiency & Accuracy',
      description: 'Save time and ensure precision in legal research and document handling.',
    },
    {
      title: 'AI-Driven Workflows',
      description: 'Automate repetitive tasks and simplify complex legal processes.',
    },
    {
      title: 'Strategic Focus',
      description: 'Free up time for core legal work and client priorities.',
    },
  ],
  cards: [
    {
      icon: <AiPowered />,
      heading: 'AI-Powered Legal Research',
      content: 'Accelerate case preparation with deep and precise legal research capabilities.',
    },
    {
      icon: <SmartLegalIcon />,
      heading: 'Smart Legal Drafting',
      content: 'Leverage data-driven insights for the intelligent drafting of legal documents.',
    },
    {
      icon: <ComprehensiveLitigationIcon />,
      heading: 'Comprehensive Litigation Support',
      content: 'End-to-end back-end support for all stages of the litigation process.',
    },
    {
      icon: <ContractLawIcon />,
      heading: 'Contract Vetting & Document Scrutiny',
      content: 'Meticulous review and analysis of contracts and legal documentation for law firms.',
    },
    {
      icon: <CurrentJudgementIcon />,
      heading: 'Current Judgment Updates',
      content:
        'Stay informed with timely updates on the latest and most relevant judicial pronouncements.',
    },
    {
      icon: <AutomationIcon />,
      heading: 'Workflow Automation & Productivity',
      content: 'Enhance team efficiency with AI-driven workflow management.',
    },
  ],
};
